import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { first } from 'rxjs';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { DepartmentDashboardService } from 'src/app/services/department-dashboard.service';
import { FarmersDetailsService } from 'src/app/services/farmers-details.service';
import * as XLSX from 'xlsx';


@Component({
  selector: 'app-pfms-payment-status',
  templateUrl: './pfms-payment-status.component.html',
  styleUrls: ['./pfms-payment-status.component.scss']
})
export class PfmsPaymentStatusComponent implements OnInit {

  public userId: any;

  xslxToJsonData: any[] = [];
  uploadFile: any;

  public pfmsPaymentStatusData: any = [];
  public ipAddress: any = '000.000.000';
  public responseDate: any = [];

  public loadingExportResponse: boolean = false;

  constructor(
    private fApplicationService: FarmersDetailsService,
    private loader: AppLoaderService,
    private messageService: MessageService,
    private activityRecordService: ActivityRecordService,
    private deptDashBoardService: DepartmentDashboardService,
    private cryptoJsService: CryptoJsService,
  ) { }

  ngOnInit(): void {
    const token: any = JSON.parse(this.cryptoJsService.DecryptToken(sessionStorage.getItem('token')));    
    let payload = atob(token?.authToken?.split('.')[1]);
    this.userId = JSON.parse(payload)?.sub;

  }

  onUploadPFMSPaymentStatus(event, formcontrol, uploadElement) {
    this.uploadFile = [];
    let workBook = null;
    let jsonData = null;
    let sheetName = null
    const reader = new FileReader();
    let file = event.files[0];
    this.uploadFile = file;
    reader.onload = (event) => {
      const data = reader.result;
      workBook = XLSX.read(data, { type: 'binary', cellText: false, cellDates: true });
      jsonData = workBook.SheetNames.reduce((initial, name) => {
        sheetName = name;
        const sheet = workBook.Sheets[name];
        initial[name] = XLSX.utils.sheet_to_json(sheet, {
          raw: false,
          dateNF: 'yyyy-mm-dd',
        });
        return initial;
      }, {});
      const dataString = JSON.stringify(jsonData);
      let statePhyFinData = JSON.parse(dataString)[sheetName];
      // this.xslxToJsonDataPersonal = JSON.parse(dataString)[sheetName];
      // if (!(this.xslxToJsonDataPersonal)) {
      if (!(statePhyFinData)) {
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'The Uploaded file has invalid data "or" Multiple sheet data is not supported!' });
        // }else if(this.xslxToJsonDataPersonal.length == 0){
      } else if (statePhyFinData.length == 0) {
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'The Uploaded file is empty!' });
      } else {
        this.addUploadedStateData(statePhyFinData);
      }
    }
    reader.readAsBinaryString(file);
    uploadElement.clear();
  }

  addUploadedStateData(value) {
    this.pfmsPaymentStatusData = value.map((val) => ({
      'AppId': val?.['App Id'],
      'FarmerName': val?.['Farmer Name'],
      'FatherName': val?.['Father Name'],
      'MobileNo': val?.['Mobile No'],
      'ContractorName': val?.['Contractor Name'],
      'Outlet': val?.['Outlet'],
      'AgreementNo': val?.['Agreement No'],
      'ProgrammeName': val?.['Programme Name'],
      'ProgrammeId': val?.['Programme Id'],
      'TotalArea': val?.['Total Area'],
      'District': val?.['District'],
      'Block': val?.['Block'],
      'Village': val?.['Village'],
      'XENReVerificationRemarks': val?.['XEN Re-verification Remarks'],
      'TotalRecommendedAmount': val?.['Total Rec Amount'],
      'CostOf85Per': val?.['85% of Cost'],
      'StateShareAmount': val?.['State_share_amt'],
      'CentreShareAmount': val?.['Centre_share_amt'],
      'TopUp': val?.['TopUp'],
      'Status': val?.['Status'],
      'Remarks': val?.['Remarks'],
      'PFMSPaymentDate': val?.['PFMSPaymentDate'],
    }))
  }



  clearPFMSpaymentStatusData() {
    this.pfmsPaymentStatusData = [];
    this.responseDate = [];
  }

  deletePFMSpaymentStatusData(index: number) {
    this.pfmsPaymentStatusData.splice(index, 1);
  }

  onSubmitStatePhyTarDate() {
    // Handle target form submission

    let reqBody = [
      {
        userId: this.userId,
        network_Id: this.ipAddress,
        terminal_Id: this.ipAddress,
        data: this.pfmsPaymentStatusData.map(val => ({
          appId: val?.AppId,
          progId: val?.ProgrammeId,
          totalRecommendedAmt: val?.TotalRecommendedAmount,
          state_share_amt: val?.StateShareAmount,
          centre_share_amt: val?.CentreShareAmount,
          pfmsPaymentDate: new Date(val?.PFMSPaymentDate),
          topUp: val?.TopUp,
          status: val?.Status,
          CAORemarks: val?.Remarks
        }))
      }
    ]
    this.insertStatePhysicalFinData(reqBody);
  }

  insertStatePhysicalFinData(reqBody) {
    let reqBodyAfterEncypt = {
      "payload": this.cryptoJsService.EncryptPayload(JSON.stringify(reqBody))
    }

    this.loader.start();
    this.loadingExportResponse = true;
    this.deptDashBoardService
      .importLotsEPC(reqBodyAfterEncypt)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.loader.close();

          // if (res == "Success") {
          //   this.messageService.add({
          //     severity: 'success',
          //     summary: 'Success Message',
          //     detail: res,
          //   });
          //   this.clearPFMSpaymentStatusData();
          // } else {
          //   this.messageService.add({
          //     severity: 'info',
          //     summary: 'Info Message',
          //     detail: res,
          //   });
          // }
          this.loadingExportResponse = false;

          this.responseDate = res;

          this.responseDate.forEach((val, i) => {
            if(val?.IsCorrect == 0){
              this.messageService.add({ severity: 'error', summary: 'Error Message', detail: this.responseDate[i].Message });
              return;
            }
            
            this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Successfully Submitted' });
          });
          this.activityRecordService.activityRecord(this.userId, 'PFMS Payment Status', ``, new Date(), `${res}`, reqBody);
        },
        error: (err) => {
          this.loadingExportResponse = false;
          this.responseDate = [];
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });

          this.activityRecordService.activityRecord(this.userId, 'PFMS Payment Status Error', ``, new Date(), `${err}`, reqBody);
        },
      });
  }

  responseGridBackgroundColor(product){
    if (product.IsCorrect == 0) {
      return '#ff8080';
    } else return '#ffffff';
  }

}
